import { resolveSegment } from "@/helpers/templates";
import { appLocales, getLocalFromPrismic } from "@/lib/i18n";

export const linkResolver = (field: any): string => {
  try {
    const segment = resolveSegment(getLocalFromPrismic(field.lang), field.type);

    let url = field.url ?? "";
    const lang = field.lang || "fr-fr";

    if (lang === "fr-fr") url = url.replace(`/${lang}`, "");
    else if (lang === "en-us") url = url.replace(`/${lang}`, "/en");
    else if (lang === "nl-be") url = url.replace(`/${lang}`, "/nl");

    if (segment && field.type) {
      const segmentInFR = resolveSegment(appLocales.defaultLocale, field.type);
      url = url.replace(`/${segmentInFR}`, `/${segment}`);
      if (url.includes(`/${segment}/${segment}`)) {
        url = url.replace(`/${segment}/${segment}`, `/${segment}`);
      }
    }

    return url;
  } catch (e) {
    console.warn("Error resolving link:", e);
    return "";
  }
};
